import { authorizedInstance } from "../config/axios"

const toQueryString = (filters) =>
  new URLSearchParams(
    Object.fromEntries(
      Object.entries(filters).filter(([, v]) => v !== undefined && v !== "")
    )
  )

export const getVideoLogs = async (filters) => {
  const params = toQueryString(filters)
  const response = await authorizedInstance.get(`/report-videos-log/?${params}`)
  return response.data
}

export const getVideoLogById = async (reportId) => {
  const response = await authorizedInstance.get(
    `/report-videos-log/${reportId}`
  )
  return response.data
}

// The same row shape getVideoLogs returns (AccessionNo, CreatedDate, IsError,
// MatchingVideos, ReportVideosUuid, radiologistProfile, scanSummary), for
// exactly one record — lets the detail pane resolve a record on its own,
// independent of where it sits in the paginated, filtered list.
export const getVideoLogRow = async (reportId) => {
  const response = await authorizedInstance.get(
    `/report-videos-log/by-id/${reportId}`
  )
  return response.data
}

// QR-code scan engagement for one report, with any feedback responses.
export const getVideoScanSummary = async (uuid) => {
  const response = await authorizedInstance.get(
    `/report-videos-log/scan-summary/${uuid}`
  )
  return response.data
}

export const getVideoScanAnalytics = async (filters) => {
  const params = toQueryString(filters)
  const response = await authorizedInstance.get(
    `/report-videos-log/scan-analytics?${params}`
  )
  return response.data
}

export const getVideoScanFilterOptions = async () => {
  const response = await authorizedInstance.get(
    "/report-videos-log/scan-analytics/filters"
  )
  return response.data
}

// Aggregated totals/facility/body-part/daily-volume data for the scan dashboard.
export const getVideoScanDashboard = async (filters) => {
  const params = toQueryString(filters)
  const response = await authorizedInstance.get(
    `/report-videos-log/scan-analytics/dashboard?${params}`
  )
  return response.data
}

export const getVideoErrorStats = async (filters) => {
  const params = toQueryString(filters)
  const response = await authorizedInstance.get(
    `/report-videos-log/error-stats?${params}`
  )
  return response.data
}

export const getVideoStatsCases = async (filters) => {
  const params = toQueryString(filters)
  const response = await authorizedInstance.get(
    `/report-videos-log/stats-cases?${params}`
  )
  return response.data
}
